import { Flex, Text, csx } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'

type Props = {
  badge: boolean
}

export function HighligthIllustration(props: Props) {
  const { badge } = props
  const { formatMessage: i18n } = useIntl()

  return (
    <svg
      width="181"
      height="215"
      viewBox="0 0 181 215"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_240_20208)">
        <rect x="3" width="175" height="208" rx="4" fill="white" />
        <rect
          x="3.5"
          y="0.5"
          width="174"
          height="207"
          rx="3.5"
          stroke="#EEEEEE"
        />
        <rect x="15" y="12" width="151" height="80" rx="4" fill="#F1F4FC" />
        <rect x="15" y="104" width="151" height="12" rx="1" fill="#EFEFEF" />
        <rect x="15" y="120" width="50" height="8" rx="1" fill="#EFEFEF" />
        <rect x="15" y="140" width="55" height="20" rx="2" fill="#EFEFEF" />
        <rect
          opacity="0.5"
          x="22"
          y="147"
          width="38"
          height="6"
          rx="1"
          fill="#DDDDDD"
        />

        <g
          data-testid="highligh-promotion-badge"
          data-visible={badge}
          className={csx({
            transition: 'opacity 0.2s',
            opacity: 0,
            '[data-visible="true"]': {
              opacity: 1,
            },
          })}
        >
          <rect
            x="15.5"
            y="172.5"
            width="150"
            height="23"
            rx="1.5"
            fill="#FFEBD7"
          />
          <rect
            x="15.5"
            y="172.5"
            width="150"
            height="23"
            rx="1.5"
            stroke="#F5AE70"
            strokeLinejoin="round"
          />

          <foreignObject x="15.5" y="172.5" width="150" height="23">
            <Flex
              align="center"
              justify="center"
              className={csx({
                height: 'full',
              })}
            >
              <Text
                variant="detail"
                tone="warning"
                className={csx({
                  textTransform: 'uppercase',
                })}
              >
                {i18n({
                  id: 'admin/promotions.form.storefront.highlight.illustration.badge',
                })}
              </Text>
            </Flex>
          </foreignObject>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_240_20208"
          x="0"
          y="0"
          width="181"
          height="215"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="7"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_240_20208"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_240_20208"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_240_20208"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
